/* eslint-disable */
import * as icon from 'vue-svgicon'
icon.register({
  'share': {
    width: 16,
    height: 16,
    viewBox: '0 0 48 48',
    data: '<path pid="0" d="M30.5 28c-.904 0-1.721.352-2.342.915l-6.412-3.782A4.91 4.91 0 0 0 21.891 24c0-.404-.062-.791-.155-1.167l6.394-3.771A3.479 3.479 0 0 0 30.5 20c1.934 0 3.5-1.566 3.5-3.5S32.434 13 30.5 13a3.499 3.499 0 0 0-3.5 3.5c0 .291.046.569.113.84l-6.254 3.688C19.964 19.87 18.578 19.11 17 19.11c-2.701 0-4.891 2.188-4.891 4.891s2.189 4.891 4.891 4.891c1.59 0 2.988-.771 3.882-1.945l6.241 3.681A3.47 3.47 0 0 0 27 31.5c0 1.934 1.566 3.5 3.5 3.5s3.5-1.566 3.5-3.5-1.566-3.5-3.5-3.5z"/>'
  }
})



// WEBPACK FOOTER //
// ./src/compiled-icons/share.js